import { FC } from 'react';

// Components
import StatisticRowsList from './StatisticRows/StatisticRowsList';

interface Props {
  title: string;
  rows?: { name: string; value: string }[];
  seasons: { label: string; value: string }[];
  currentSeason?: string;
  handleSeasonChange: (value: string) => void;
  showStatistics: boolean;
}

const SeasonStatistics: FC<Props> = ({ title, rows, currentSeason, seasons, handleSeasonChange, showStatistics }) => {
  if (!rows || !showStatistics) {
    return null;
  }

  return (
    <div className='stats-rows-wrapper pt-4 px-4'>
      <StatisticRowsList
        title={title}
        rows={rows}
        rowsNumber={rows.length}
        currentSeason={currentSeason}
        seasons={seasons}
        handleSeasonChange={handleSeasonChange}
      />
    </div>
  );
};

export default SeasonStatistics;
